// dilip 01/25/2023 2698964415 Filter Criteria UI change for Data Import.
// Suresh Peddavoora 01/25/2023 2698964415 Field Value Autocomplete Alignments
// dilip 01/27/2023 2698964415 Filter Criteria UI change for Data Import.
// Sohel 01/03/2023 2698964415 Filter Criteria Condition Changes
// Sohel 04/13/2023 2698964415 FIxed page Break Issue
// Guru Prasad 04/25/2023 2700912712 fixed input fields based on conditional rendering
// Akhila 04/28//2023 2698964415 modified in field type and sql output
// Akhila 06/02/2023 2698964415 Date field captial and is not bug fixed
// Akhila 06/03/2023 2698964415 between T+/T- and manually date issue fix and label change
// Akhila 06/09/2023 2698964415 bug fix is not sql output
// Akhila 06/16/2023 2698811066 added TODAY and T in sql output
// Sohel 06/21/2023 2698811066 added Repository name
// Sohel 10/16/2023 2698811066 Fixed Date Format issue
import React, {useContext} from 'react';
import {TextField} from '@material-ui/core';
import moment from 'moment';
import {ErrorMessage} from './ErrorMessage';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import {ThemeContext} from '../../themes/ThemeProvider';
import {hideValuesConditions} from './FilterCriteriaBuilder';

export const formatDate = (val) => {
  return moment(val).format('MM/DD/YYYY');
};
export const getValue = (values) => {
  const a = values?.split(' ')?.join('');
  const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
  if (dateValue?.toUpperCase() === 'TODAY') {
    return a?.replace(dateValue, 'cast(now()as date)');
  } else if (values?.charAt(0)?.toUpperCase() === 'T') {
    return a?.replace(values?.charAt(0), 'cast(now()as date)');
  } else {
    return `'${values}'`;
  }
};

export const getOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Contain', value: 'contains'},
      {label: 'Doesn\'t contain', value: 'notContains'},
      {label: 'In', value: 'in'},
      {label: 'Not in', value: 'notIn'},
      {label: 'Starts with', value: 'startsWith'},
      {label: 'Ends with', value: 'endsWith'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  case 'number':
  case 'amount':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Less than', value: '<'},
      {label: 'Greater than', value: '>'},
      {label: 'Less than equal', value: '<='},
      {label: 'Greater than equal', value: '>='},
      {label: 'Between', value: 'BETWEEN'},
      {label: 'Not between', value: 'NOT BETWEEN'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  case 'date':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Less than', value: '<'},
      {label: 'Greater than', value: '>'},
      {label: 'Less than equal', value: '<='},
      {label: 'Greater than equal', value: '>='},
      {label: 'Between', value: 'BETWEEN'},
      {label: 'Not between', value: 'NOT BETWEEN'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  default:
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Contain', value: 'contains'},
      {label: 'Doesn\'t contain', value: 'notContains'},
      {label: 'In', value: 'in'},
      {label: 'Not in', value: 'notIn'},
      {label: 'Starts with', value: 'startsWith'},
      {label: 'Ends with', value: 'endsWith'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  }
};

export const getWorkqueueFilterOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      {label: 'is', value: '=', textVal: 'is'},
      {label: 'is not', value: '<>', textVal: 'isNot'},
      {label: 'contain', value: 'contains', textVal: 'contains'},
      {label: 'is null', value: 'isNull', textVal: 'isNull'},
      {label: 'is not null', value: 'isNotNull', textVal: 'isNotNull'},
    ];
  case 'number':
  case 'date':
  case 'amount':
    return [
      {label: 'is', value: '=', textVal: 'is'},
      {label: 'is not', value: '<>', textVal: 'isNot'},

      {label: 'less than', value: '<', textVal: 'lessThan'},
      {label: 'greater than', value: '>', textVal: 'greaterThan'},
      {label: 'less than equal', value: '<=', textVal: 'lessThanEqual'},
      {label: 'greater than equal', value: '>=', textVal: 'greaterThanEqual'},
      {label: 'between', value: 'BETWEEN', textVal: 'between'},
      {label: 'not between', value: 'NOT BETWEEN', textVal: 'notBetween'},
      {label: 'is null', value: 'isNull', textVal: 'isNull'},
      {label: 'is not null', value: 'isNotNull', textVal: 'isNotNull'},
    ];
  default:
    return [
      {label: 'is', value: '=', textVal: 'is'},
      {label: 'is not', value: '<>', textVal: 'isNot'},
      {label: 'contain', value: 'contains', textVal: 'contains'},
      {label: 'is null', value: 'isNull', textVal: 'isNull'},
      {label: 'is not null', value: 'isNotNull', textVal: 'isNotNull'},
    ];
  }
};

export const GetFields = ({
  fieldType,
  type,
  rule,
  handleUpdateRule,
  name,
  name1,
  error,
  handleBlur,
  mappedFieldsData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const hideValuesConditions = ['isBlank', 'isNotBlank', 'isEmpty', 'isNotEmpty'];
  const valueErrorMesg = (
    <ErrorMessage
      render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
      name={name}
    />
  );
  const commonProps = {
    handleBlur,
    fullWidth: true,
  };
  const value1ErrorMesg = (
    <ErrorMessage
      render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
      name={name1}
    />
  );
  if (fieldType === 'file' && !hideValuesConditions.includes(rule?.condition?.value)) {
    return (
      <>
        <div>
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            label="To Field Value"
            value={rule?.value || ''}
            name={'value'}
            options={mappedFieldsData || []}
            getOptionLabel={(option) => option?.repositoryFieldCode || ''}
            renderOption={(option) => option?.repositoryName + ' - ' + option?.repositoryFieldCode}
            size="small"
            autoHighlight
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={handleBlur}
                fullWidth
                margin="dense"
                label="To Field Value"
                name="value"
                error={error}
                placeholder="Select To Filed Value"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleUpdateRule('value', data || '');
            }}
          />
          {valueErrorMesg}
        </div>
      </>
    );
  }

  if (!hideValuesConditions.includes(rule?.condition?.value)) {
    switch (type) {
    case 'text':
    case 'ssn':
    case 'phone':
      return (
        <>
          <TextField
            {...commonProps}
            label="To field value"
            value={rule?.value}
            name={name}
            placeholder="Enter To field value"
            error={error}
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </>
      );
    case 'number':
    case 'amount':
      if (rule?.condition.value == 'BETWEEN') {
        return (
          <div className="d-flex">
            <div className="label-text mr-10">From</div>
            <div>
              <TextField
                {...commonProps}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                value={rule?.value}
                name={name}
                error={error}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            <div className="label-text">To</div>
            <div>
              <TextField
                {...commonProps}
                value={rule?.value1}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                name={`${name}.value1`}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule.condition.value == 'NOT BETWEEN') {
        return (
          <div className="d-flex align-items-center">
            {/* <div className="start-num"></div> */}
            <div>
              <TextField
                // label="Value"
                {...commonProps}
                type="number"
                name={name}
                placeholder="Enter value"
                // variant="outlined"
                value={rule?.value}
                error={error}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            <div className="label-text and-value-text">and</div>
            <div>
              <TextField
                {...commonProps}
                value={rule?.value1}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                name={`${name}.value1`}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else {
        return (
          <>
            <TextField
              {...commonProps}
              label="Value"
              value={rule?.value}
              name={name}
              type="number"
              error={error}
              placeholder="Enter value"
              onChange={(e) => {
                handleUpdateRule('value', e.target.value);
              }}
            />
            {valueErrorMesg}
          </>
        );
      }
    case 'date':
      if (rule?.condition?.value === 'BETWEEN') {
        return (
          <div className="d-flex">
            {/* <div className="label-text m-0 mr-10">From</div> */}
            <div>
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="From Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={name}
                value={rule?.value}
                onChange={(e) => {
                  handleUpdateRule('value', e.target?.value?.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {/* <KeyboardDatePicker
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  name={name}
                  value={rule?.value}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  // name="effectiveDate"
                  minDateMessage={null}
                  error={error}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="From"
                  onChange={(val) => {
                    handleUpdateRule("value", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              {valueErrorMesg}
            </div>
            <div className="label-text and-datepicker-text">and</div>
            {/* <div className="label-text">To</div> */}
            <div className="to-datepicker-field">
              {/* <KeyboardDatePicker
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  value={rule?.value1}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  // name="effectiveDate"
                  minDateMessage={null}
                  name={`${name}.value1`}
                  error={false}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="To"
                  onChange={(val) => {
                    handleUpdateRule("value1", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="To Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={`${name}.value1`}
                value={rule?.value1}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target?.value?.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule?.condition?.value === 'NOT BETWEEN') {
        return (
          <div className="d-flex">
            <div>
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="From Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={name}
                value={rule?.value}
                onChange={(e) => {
                  handleUpdateRule('value', e.target?.value?.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {/* <KeyboardDatePicker
                  // className={` ${classes.labelName} ${classes.datePicker}`}
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  name={name}
                  value={rule?.value}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  // name="effectiveDate"
                  minDateMessage={null}
                  error={error}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="Value"
                  onChange={(val) => {
                    handleUpdateRule("value", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              {valueErrorMesg}
            </div>
            <div className="label-text and-datepicker-text">and</div>
            <div>
              <TextField
                margin="dense"
                // variant="outlined"
                // className={` ${classes.labelName} ${classes.inputLabel}`}
                placeholder={`MM/DD/YYYY or Today or T`}
                label="To Field Value"
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
                //   // inputComponent: NumberFormatterPostiveNegavtive,
                // }}
                name={`${name}.value1`}
                value={rule?.value1}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target?.value?.toUpperCase());
                }}
                fullWidth
                onBlur={handleBlur}
                error={error}
              />
              {/* <KeyboardDatePicker
                  // className={` ${classes.labelName} ${classes.datePicker}`}
                  {...commonProps}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  fullWidth
                  value={rule.value1}
                  // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                  name={`${name}.value1`}
                  minDateMessage={null}
                  error={false}
                  helperText={null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // inputVariant="outlined"
                  label="Value"
                  onChange={(val) => {
                    handleUpdateRule("value1", val);
                  }}
                  autoOk
                  margin="dense"
                /> */}
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else {
        return (
          <>
            {/* <KeyboardDatePicker
                // className={` ${classes.labelName} ${classes.datePicker}`}
                {...commonProps}
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                fullWidth
                value={rule.value}
                // minDate={new Date(moment(dateValidationData).add(1, "days").format("YYYY-MM-DD"))}
                name={name}
                minDateMessage={null}
                error={error}
                helperText={null}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputVariant="outlined"
                label="Value"
                onChange={(val) => {
                  handleUpdateRule("value", val);
                }}
                autoOk
                margin="dense"
              /> */}
            <TextField
              margin="dense"
              // variant="outlined"
              // className={` ${classes.labelName} ${classes.inputLabel}`}
              placeholder={`MM/DD/YYYY or Today or T`}
              label="To Field Value"
              // InputLabelProps={{
              //   shrink: true,
              // }}
              // InputProps={{
              //   startAdornment: <InputAdornment position="start">T</InputAdornment>,
              //   // inputComponent: NumberFormatterPostiveNegavtive,
              // }}
              name={name}
              value={rule?.value}
              onChange={(e) => {
                handleUpdateRule('value', e.target?.value?.toUpperCase());
              }}
              fullWidth
              onBlur={handleBlur}
              error={error}
            />
            {valueErrorMesg}
          </>
        );
      }
    default:
      return (
        <>
          <TextField
            {...commonProps}
            label="Value"
            value={rule?.value}
            placeholder="Enter value"
            name={name}
            error={error}
            fullWidth
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </>
      );
    }
  }
  return null;
};
const numberTypes = ['amount', 'number'];
export const generateSql = (obj) => {
  let sqlQuery = obj?.field?.globalField;
  const dontConvertLowerCase = ['date', 'number', 'amount'];
  let {
    value,
    value1,
    type,
    // condition: { value: conditionValue },
    condition,
  } = obj;
  const conditionValue = condition?.value ? condition.value : '';
  const currFieldType = obj?.field?.fieldType?.toLowerCase();
  if (type?.value === 'file') {
    value =
      typeof value?.repositoryFieldCode === 'string' ?
        `file:${value?.repositoryFieldCode.toLowerCase()}` :
        '';
    if (!dontConvertLowerCase.includes(currFieldType)) {
      sqlQuery = `lower(${obj?.field?.globalField})`;
    }
    sqlQuery += conditionValue;
    if (['in', 'notIn']?.includes(conditionValue)) {
      sqlQuery += ' ' + `('${value.toLowerCase()}')`;
    } else {
      sqlQuery += ' ' + `'${value.toLowerCase()}'`;
    }
  } else if (type?.value === 'value') {
    if (value && currFieldType !== 'date') {
      value = value.toLowerCase();
    }
    if (value1 && currFieldType !== 'date') {
      value1 = value1.toLowerCase();
    }

    if (!dontConvertLowerCase.includes(currFieldType)) {
      sqlQuery = `lower(${obj?.field?.globalField})`;
    }
    console.log(conditionValue, 'CONDITIONAL');
    if (conditionValue) {
      switch (conditionValue) {
      case '=':
        sqlQuery += ' = ';
        if (currFieldType === 'date') {
          // sqlQuery += " " + `'${formatDate(value)}'`;
          if (type?.value === 'file') {
            sqlQuery += ' ' + `${value}`;
          } else if (value?.slice(0, 5)?.toUpperCase() === 'TODAY' || value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `${getValue(value)}`;
          } else {
            sqlQuery += `'${value}'`;
          }
        } else if (type?.value === 'file') {
          sqlQuery += ' ' + `'${value}'`;
        } else {
          sqlQuery += ' ' + `'${value.toLowerCase()}'`;
        }
        // } else {
        //   sqlQuery += " " + `'${value.toLowerCase()}'`;
        // }
        break;
      case '<>':
        sqlQuery += ' ' + conditionValue;
        if (currFieldType === 'date') {
          sqlQuery = `( ${obj.field.globalField}`;
          // sqlQuery += ` '${formatDate(value)}' or ${obj.field.globalField} is null )`;
          if (type?.value === 'file') {
            sqlQuery += ` ${value} or ${obj.field.globalField} is null )`;
          } else if (value?.slice(0, 5)?.toUpperCase() === 'TODAY' || value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            // sqlQuery += `${getValue(value)}`;
            sqlQuery += ' ' + conditionValue;
            sqlQuery += ` ${getValue(value)} or ${obj.field.globalField} is null )`;
          } else {
            // sqlQuery += ` now() ${value} or ${obj.field.globalField} is null )`;
            sqlQuery += ' ' + conditionValue;
            sqlQuery += ` '${value}' or ${obj.field.globalField} is null )`;
          }
        } else if (type?.value === 'file') {
          sqlQuery += ' ' + `'${value}'`;
        } else {
          sqlQuery = `( ${obj.field.globalField}`;
          if (!dontConvertLowerCase.includes(currFieldType)) {
            sqlQuery = `( lower(${obj.field.globalField})`;
          }

          sqlQuery += ' ' + conditionValue;
          sqlQuery += ' ' + `'${value}' or ${obj.field.globalField} is null )`;
        }
        break;
      case 'contains':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '%${value}%'`;

        break;
      case 'notContains':
        sqlQuery = `( ${obj.field.globalField}`;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }
        sqlQuery += ' NOT LIKE ';
        sqlQuery += ` '%${value}%'  or ${obj.field.globalField} is null )`;

        break;
      case 'startsWith':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '${value}%'`;

        break;
      case 'endsWith':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '%${value}'`;

        break;
      case 'BETWEEN':
      case 'NOT BETWEEN':
        // if (currFieldType === "date") {
        //   sqlQuery += " " + conditionValue + " ";
        //   sqlQuery +=
        //     `'${formatDate(value)}'` + " AND " + `'${value1 ? formatDate(value1) : ""}'`;
        // }
        if (value?.charAt(0)?.toUpperCase() !== 'T' && value1?.charAt(0)?.toUpperCase() !== 'T') {
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `'${value}' AND '${value1}'`;
          // sqlQuery += `'${value} or ${obj.field.globalField} is null )'`;
        } else if (value?.slice(0, 5)?.toUpperCase() === 'TODAY' || value?.charAt(0)?.toUpperCase() === 'T') {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += ' ' + conditionValue + ' ';
          // `'${formatDate(value)}'` + " AND " + `'${value1 ? formatDate(value1) : ""}'`;
          sqlQuery += `${getValue(value)} AND ${getValue(value1)}`;
        } else {
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `'${value}'` + ' AND ' + `'${value1}'`;
        }
        break;

      case 'isBlank':
        if (currFieldType != 'date') {
          sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '' )`;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NULL )`;
        }
        if (numberTypes.includes(currFieldType)) {
          sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '0' )`;
        }
        break;
      case 'isNotBlank':
        if (currFieldType != 'date') {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '' )`;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL )`;
        }

        if (numberTypes.includes(currFieldType)) {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '0' )`;
        }
        break;
      case 'in':
        sqlQuery += ' IN (';
        const inSplitArr = value.split(',');
        inSplitArr.forEach((el, i) =>
          i === inSplitArr.length - 1 ?
            (sqlQuery += `'${el?.trim()}'`) :
            (sqlQuery += `'${el?.trim()}',`),
        );
        sqlQuery += ')';
        break;
      case 'notIn':
        sqlQuery = `( ${obj.field.globalField}`;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }
        sqlQuery += ' NOT IN (';
        const splitArr = value.split(',');
        splitArr.forEach((el, i) =>
          i === splitArr.length - 1 ?
            (sqlQuery += `'${el?.trim()}'`) :
            (sqlQuery += `'${el?.trim()}',`),
        );
        sqlQuery += `) or ${obj.field.globalField} is null )`;
        break;
      default:
        if (currFieldType === 'date') {
          sqlQuery += ' ' + conditionValue;
          // sqlQuery += ` '${formatDate(value)}'`;
          if (type?.value === 'file') {
            sqlQuery += ' ' + `${value}`;
          } else if (value?.slice(0, 5)?.toUpperCase() === 'TODAY' || value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `${getValue(value)}`;
          } else {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `'${value}'`;
          }
        } else {
          sqlQuery += ' ' + conditionValue;
          sqlQuery += ' ' + `'${value}'`;
        }
      }
    }
  }
  if (hideValuesConditions?.includes(conditionValue)) {
    if (value && currFieldType !== 'date') {
      value = value.toLowerCase();
    }
    if (value1 && currFieldType !== 'date') {
      value1 = value1.toLowerCase();
    }

    if (!dontConvertLowerCase.includes(currFieldType)) {
      sqlQuery = `lower(${obj?.field?.globalField})`;
    }
    console.log(conditionValue, 'CONDITIONAL');
    if (conditionValue) {
      switch (conditionValue) {
      case '=':
        sqlQuery += ' = ';
        if (currFieldType === 'date') {
          // sqlQuery += " " + `'${formatDate(value)}'`;
          if (type?.value === 'file') {
            sqlQuery += ' ' + `${value}`;
          } else if (value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `${getValue(value)}`;
          } else {
            sqlQuery += `'${value}'`;
          }
        } else if (type?.value === 'file') {
          sqlQuery += ' ' + `'${value}'`;
        } else {
          sqlQuery += ' ' + `'${value.toLowerCase()}'`;
        }
        // } else {
        //   sqlQuery += " " + `'${value.toLowerCase()}'`;
        // }
        break;
      case '<>':
        if (currFieldType === 'date') {
          sqlQuery = `( ${obj.field.globalField}`;
          sqlQuery += ' ' + conditionValue;
          // sqlQuery += ` '${formatDate(value)}' or ${obj.field.globalField} is null )`;
          if (type?.value === 'file') {
            sqlQuery += ` ${value} or ${obj.field.globalField} is null )`;
          } else if (value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            // sqlQuery += `${getValue(value)}`;
            sqlQuery += `${getValue(value)} or ${obj.field.globalField} is null )`;
          } else {
            // sqlQuery += ` now() ${value} or ${obj.field.globalField} is null )`;
            sqlQuery += `'${value}' or ${obj.field.globalField} is null )`;
          }
        } else if (type?.value === 'file') {
          sqlQuery += ' ' + `'${value}'`;
        } else {
          sqlQuery = `( ${obj.field.globalField}`;
          if (!dontConvertLowerCase.includes(currFieldType)) {
            sqlQuery = `( lower(${obj.field.globalField})`;
          }

          sqlQuery += ' ' + conditionValue;
          sqlQuery += ' ' + `'${value}' or ${obj.field.globalField} is null )`;
        }
        break;
      case 'contains':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '%${value}%'`;

        break;
      case 'notContains':
        sqlQuery = `( ${obj.field.globalField}`;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }
        sqlQuery += ' NOT LIKE ';
        sqlQuery += ` '%${value}%'  or ${obj.field.globalField} is null )`;

        break;
      case 'startsWith':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '${value}%'`;

        break;
      case 'endsWith':
        sqlQuery += ' LIKE ';
        sqlQuery += ` '%${value}'`;

        break;
      case 'BETWEEN':
      case 'NOT BETWEEN':
        if (currFieldType === 'date') {
          // sqlQuery += " " + conditionValue + " ";
          //   sqlQuery += `'${formatDate(value)}'` + " AND " + `'${value1 ? formatDate(value1) : ""}'`;
          // }
          // if (value?.charAt(0) !== "T") {
          //   console.log("simple");
          //   sqlQuery += " " + conditionValue + " ";
          //   sqlQuery += `'${value}' AND '${value1}'`;
          //   // sqlQuery += `'${value} or ${obj.field.globalField} is null )'`;
          // }
          if (value?.charAt(0)?.toUpperCase() !== 'T' && value1?.charAt(0)?.toUpperCase() !== 'T') {
            sqlQuery += ' ' + conditionValue + ' ';
            sqlQuery += `'${value}' AND '${value1}'`;
          } else if (value?.charAt(0)?.toUpperCase() === 'T' || value1?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += ' ' + conditionValue + ' ';
            sqlQuery += `${getValue(value)} AND ${getValue(value1)}`;
          }
        } else {
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `'${getValue(value)}'` + ' AND ' + `'${getValue(value1)}'`;
        }
        break;

      case 'isBlank':
        if (currFieldType != 'date') {
          sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '' )`;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NULL )`;
        }
        if (numberTypes.includes(currFieldType)) {
          sqlQuery = `( ${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '0' )`;
        }
        break;
      case 'isNotBlank':
        if (currFieldType != 'date') {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '' )`;
        } else {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL )`;
        }

        if (numberTypes.includes(currFieldType)) {
          sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '0' )`;
        }
        break;
      case 'in':
        sqlQuery += ' IN (';
        const inSplitArr = value.split(',');
        inSplitArr.forEach((el, i) =>
          i === inSplitArr.length - 1 ?
            (sqlQuery += `'${el?.trim()}'`) :
            (sqlQuery += `'${el?.trim()}',`),
        );
        sqlQuery += ')';
        break;
      case 'notIn':
        sqlQuery = `( ${obj.field.globalField}`;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }
        sqlQuery += ' NOT IN (';
        const splitArr = value.split(',');
        splitArr.forEach((el, i) =>
          i === splitArr.length - 1 ?
            (sqlQuery += `'${el?.trim()}'`) :
            (sqlQuery += `'${el?.trim()}',`),
        );
        sqlQuery += `) or ${obj.field.globalField} is null )`;
        break;
      default:
        if (currFieldType === 'date') {
          sqlQuery += ' ' + conditionValue;
          // sqlQuery += ` '${formatDate(value)}'`;
          if (type?.value === 'file') {
            sqlQuery += ' ' + `${value}`;
          } else if (value?.charAt(0)?.toUpperCase() === 'T') {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `${getValue(value)}`;
          } else {
            // sqlQuery += " " + " now() " + `${value}`;
            sqlQuery += `'${value}'`;
          }
        } else {
          sqlQuery += ' ' + conditionValue;
          sqlQuery += ' ' + `'${value}'`;
        }
      }
    }
  }

  obj.sqlValue = sqlQuery;
};
